import { render, staticRenderFns } from "./EocViewDocumentsSidebar.vue?vue&type=template&id=64626127&scoped=true&"
import script from "./EocViewDocumentsSidebar.vue?vue&type=script&lang=js&"
export * from "./EocViewDocumentsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EocViewDocumentsSidebar.vue?vue&type=style&index=0&id=64626127&prod&scoped=true&lang=css&"
import style1 from "./EocViewDocumentsSidebar.vue?vue&type=style&index=1&id=64626127&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64626127",
  null
  
)

export default component.exports